/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import AppDropdown from "../AppDropdown";

export default function ReactHookFormDropdown({
  label,
  name,
  isRequired,
  placeholder,
  rules,
  id,
  text,
  info,
  data,
  disabled,
  errors,
  filterable,
  control,
  onChange,
  dropdownProps,
  controlStyles,
  disablePlaceholderItem,
}) {
  // console.log("validate rules", rules);
  return (
    <FormControl
      isRequired={Boolean(isRequired)}
      style={controlStyles ? controlStyles : {}}
    >
      <FormLabel>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => {
          return (
            <AppDropdown
              {...dropdownProps}
              disabled={disabled}
              className={errors[name] ? "error-field" : ""}
              value={field.value || null}
              data={data}
              defaultItem={
                disablePlaceholderItem
                  ? undefined
                  : { [id]: "0", [text]: placeholder }
              }
              textField={text}
              dataItemKey={id}
              filterable={filterable}
              onChange={(res) => {
                if (onChange) {
                  if (rules && "validate" in rules) {
                    if (rules.validate(res.value)) {
                      onChange(res);
                    }
                  } else {
                    onChange(res);
                  }
                }
                if (res.value[id] !== "0") {
                  field.onChange(res.value);
                } else {
                  field.onChange(null);
                }
              }}
            />
          );
        }}
      />
      {info ? (
        <p className="error-message" style={{ color: "black" }}>
          {info || ""}
        </p>
      ) : (
        <></>
      )}

      {errors[name] ? (
        <p className="error-message">
          {errors[name].message || "Please Select Field!"}
        </p>
      ) : (
        <></>
      )}
    </FormControl>
  );
}
